<template>
  <div class="col-12 page_content_area">
    <div class="container enterprises_content_area">
      <div class="white_block">
        <enterprise-intern-form
          :is-edit="true"
          @load="loadFormData"
          @submit="submitInternEdit"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import EnterpriseInternForm from './InternForm'
export default {
  name: 'EnterprisesInternEditContent',
  components: {
    EnterpriseInternForm
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentInternBasicInfoGetter',
      'currentInternStatusGetter',
    ]),
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/enterprises', [
      'getEnterpriseInternForm',
      'updateEnterpriseInternForm',
    ]),
    async loadFormData (enter_area) {
      await this.getEnterpriseInternForm();
      if(this.currentInternStatusGetter == 'is_enabled') {
        this.currentInternBasicInfoGetter.turnover = +this.currentInternBasicInfoGetter.turnover;
        enter_area.set_form_data(this.currentInternBasicInfoGetter);
        this.togglePageLoader(false);
      }
      else {
        this.$router.push({ path: '/enterprises' });
      }
    },
    submitInternEdit (form_data) {
      this.updateEnterpriseInternForm(form_data);
    },
  }
}
</script>
